module.exports = __webpack_public_path__ + "img/4_37.e2ab7a21.png";